import HomePage from '../../components/home/HomePage'

export default function AppDE() {
  return <HomePage lang="de" />
}
